"use client";
import TestimonialSingle from './TestimonialSingle';
import { Slider, Slide } from '../../widgets/slider';
import styles from './styles.module.scss';

const TestimonialSlider = props => {
    const {testimonials} = props || {};

    const renderSlides = () => {
        if(!testimonials || testimonials?.length === 0) return null;

        return testimonials && testimonials.map((item, index)=> {
            return(
                <Slide key={index}>
                    <TestimonialSingle slide={true} {...item?.testimonial}/>
                </Slide>
            );
        })
    }

    return(
        <Slider
            className={styles.testSlider}
            slidesPerView={1}
            loop={true}
            pagination={{
                clickable: true,
                el: '.testimonial-pagination',
                renderBullet: (index, className) => {
                    return '<span class="' + className + ' testimonial-custom-pagination"></span>';
                  }
            }}
            fadeEffect={{ crossFade: true }} 
            effect={"fade"}
            nextEl={'.swiper-button-next-custom'}
            navigation={{
                nextEl: '.button-next-custom',
                prevEl: '.button-prev-custom',
            }}
        >
        {renderSlides()}
    </Slider>
    );
}


export default TestimonialSlider;
